<template>
  <div >
<!--    <Header></Header>-->
<!--    <router-view></router-view>-->
<!--    <Footer></Footer>-->
          <p style="margin-top: 5%;margin-left: 5%;font-weight: bold;font-size: xxx-large">敬请期待…</p>
  </div>
</template>
<script>
// (function(i, s, o, g, r, a, m) {
//        i["DaoVoiceObject"] = r;
//        i[r] = i[r] || function() {
//          (i[r].q = i[r].q || []).push(arguments)
//        }, i[r].l = 1 * new Date();
//        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
//        a.async = 1;
//        a.src = g;
//        a.charset = "utf-8";
//        m.parentNode.insertBefore(a, m)
//      })(window, document, "script", ('https:' == document.location.protocol ? 'https:' : 'http:') +
//                    "//widget.daovoice.io/widget/d6934b2d.js", "daovoice")
//    daovoice('init', {
// 			        app_id: "d6934b2d"
// 		            });
// 	daovoice('update');

import Header from './components/header'
import Footer from './components/footer'

export default {
  data () {
    return {}
  },
  components: {
    // Header,
    // Footer
  },
  mounted () {
    this.dao()
  },
  beforeDestroy () {

  },
  methods: {
    dao() {

    }

  }
}



</script>
